import { Controller } from '@hotwired/stimulus';

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

export default class extends Controller {
  static targets = ['form']

  change() {
    const form = this.formTarget;
    const submitButton = form.querySelector('button[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
    }

    const formData = new FormData(form);

    fetch(form.action, {
      method: form.method,
      headers: {
        'Accept': 'text/javascript',
        'X-CSRF-Token': csrfToken()
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(responseText => {
        eval(responseText);
      })
      .catch(error => {
        console.error('フォームの送信に失敗しました:', error);
        const errorMessage = document.createElement('div');
        errorMessage.className = 'alert alert-danger mt-3';
        errorMessage.textContent = 'フォームの送信中にエラーが発生しました。もう一度お試しください。';
        form.appendChild(errorMessage);

        if (submitButton) {
          submitButton.disabled = false;
        }

        setTimeout(() => errorMessage.remove(), 5000); // 5秒後にエラーメッセージを削除
      });
  }
}
